import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { ImageThumbnailWrapper } from 'approot/shared/images/images.style';
import {
  ButtonBaseProps,
  ButtonBaseStyled,
} from 'approot/shared/styles/buttons/base-button.style';
import {
  coolGrey2,
  grey3,
  grey4,
  grey5,
} from 'approot/shared/styles/colours.style';
import { FlexSpaceBetween } from 'approot/shared/styles/flex.style';
import { spacing16, spacing24 } from 'approot/shared/styles/spacing.style';
import { skeletonState } from 'approot/shared/styles/transitions.style';
import { TabsStyled } from 'approot/shared/tabs/tabs.style';

export const VocabularyTabs = styled.div`
  border-bottom: 1px solid ${grey4};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${rem(spacing16)};

  ${TabsStyled} {
    & > button {
      margin-right: ${rem(spacing24)};
    }
  }
`;

export const VocabularyDefinitionExample = styled(FlexSpaceBetween)`
  align-items: flex-start;
  border-bottom: 1px solid ${grey5};
  padding-bottom: ${rem(spacing24)};
`;

type VocabularyDefinitionImageProps = {
  $isLoading?: boolean;
};
export const VocabularyDefinitionImage = styled.button<
  VocabularyDefinitionImageProps & ButtonBaseProps
>`
  ${ButtonBaseStyled}

  background-color: ${grey3};
  height: auto;
  flex-shrink: 0;
  margin-right: ${rem(spacing16)};
  min-width: ${rem(64)};
  min-height: ${rem(64)};
  padding: 0;

  ${ImageThumbnailWrapper} {
    border: none;
  }

  svg path {
    stroke: ${grey5};
  }

  ${({ $isLoading }) =>
    $isLoading &&
    `
    ${skeletonState}  
    background-color: ${coolGrey2};
  `}
`;
